module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7jUls"))).then(() => parcelRequire('d0iPb'));